const IMAGE_CACHE_PARAM = "smartix_cb"

const stripImageCacheBust = imageUrl => {
  if (!imageUrl || typeof imageUrl !== "string") return imageUrl ?? null

  try {
    const url = new URL(imageUrl)
    url.searchParams.delete(IMAGE_CACHE_PARAM)
    return url.toString()
  }
  catch {
    return imageUrl.replace(new RegExp(`([?&])${IMAGE_CACHE_PARAM}=[^&#]*(&)?`), (match, prefix, suffix) => {
      if (prefix === "?" && suffix) return "?"
      if (prefix === "&" && suffix) return "&"
      return ""
    }).replace(/\?$/, "")
  }
}

const getImageRevision = image => {
  if (!image) return null
  return image.uploaded_date ?? image.updated_at ?? image.created_at ?? image.id ?? null
}

const toDisplayImageUrl = ({ imageUrl, revision }) => {
  const baseUrl = stripImageCacheBust(imageUrl)
  if (!baseUrl || !revision) return baseUrl

  try {
    const url = new URL(baseUrl)
    url.searchParams.set(IMAGE_CACHE_PARAM, String(revision))
    return url.toString()
  }
  catch {
    return baseUrl
  }
}

const urlsMatchIgnoringCacheBust = (left, right) => {
  return stripImageCacheBust(left) === stripImageCacheBust(right)
}

export {
  getImageRevision,
  stripImageCacheBust,
  toDisplayImageUrl,
  urlsMatchIgnoringCacheBust
}
